import React from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { Box, InputPassword, Tooltip, Typography } from '@lyearn/ui';

import CheckListItem from './components/CheckListItem';
import { usePasswordRules } from './hooks/usePasswordRules';
import { PasswordWithTooltipProps } from './types';

const PasswordWithTooltipDesktop = ({
  isError,
  errorMessage,
  password,
  onChangeText,
  placeholder,
  onBlur,
  size = 'large',
}: PasswordWithTooltipProps) => {
  const { passwordRules, isFailing } = usePasswordRules(password);
  const { t } = useTranslation();
  const [showPasswordInfo, { on, off }] = useToggle(false);

  return (
    <>
      <Tooltip
        open={showPasswordInfo && isFailing}
        placement="right"
        title={
          <Box className="my-8 mx-4 me-20">
            <Typography variant="body-short-02">{t('Auth:passwordInfo')}</Typography>
            <Box className="mt-16">
              {passwordRules.map((rule) => (
                <CheckListItem key={rule.message} checked={!rule.isFailing} label={rule.message} />
              ))}
            </Box>
          </Box>
        }>
        <InputPassword
          fullWidth
          error={isError}
          margin="dense"
          placeholder={placeholder}
          size={size}
          onBlur={() => {
            off();
            onBlur?.();
          }}
          onChangeText={onChangeText}
          onFocus={on}
        />
      </Tooltip>
      {errorMessage && isError ? (
        <Typography className="mt-8 mb-8 ms-8" color="text-text-error" variant="body-short-03">
          {errorMessage}
        </Typography>
      ) : null}
    </>
  );
};

export default React.memo(PasswordWithTooltipDesktop);
